<div class="row g-3 align-items-end mb-4">
  <div class="col-md-3">
    <label class="form-label">Empregador</label>
    <select class="form-select" [ngModel]="empregadorSelecionado" (ngModelChange)="empregadorSelecionadoChange.emit($event)">
      <option value="">Selecione</option>
      <option *ngFor="let item of empregadores" [value]="item.id">{{ item.razaoSocial }}</option>
    </select>
  </div>
  <div class="col-md-3">
    <label class="form-label">Departamento</label>
    <app-seletor-multiplo-departamentos
      [departamentos]="departamentos"
      [idsSelecionados]="departamentoSelecionado"
      (idsSelecionadosChange)="alterarDepartamento($event)">
    </app-seletor-multiplo-departamentos>
  </div>
  <div class="col-md-3">
    <label class="form-label">Funcionario</label>
    <app-busca-pesquisavel
      nomeCampo="buscaFuncionarioExportacao"
      rotuloBuscar="Pesquisar funcionario"
      placeholder="Todos os funcionarios"
      [termo]="buscaFuncionario"
      (termoChange)="buscaFuncionarioChange.emit($event)"
      [itens]="funcionariosFiltrados"
      [rotuloItem]="rotuloFuncionario"
      [detalheItem]="detalheFuncionario"
      (buscar)="abrirModalFuncionarios.emit()"
      (selecionar)="selecionarFuncionario.emit($event)">
    </app-busca-pesquisavel>
  </div>
  <div class="col-md-2">
    <label class="form-label">Data inicial</label>
    <input class="form-control" type="date" [ngModel]="dataInicial" (ngModelChange)="alterarDataInicial($event)">
  </div>
  <div class="col-md-2">
    <label class="form-label">Data final</label>
    <input class="form-control" type="date" [ngModel]="dataFinal" (ngModelChange)="alterarDataFinal($event)">
  </div>
  <div class="col-md-2">
    <label class="form-label">Formato</label>
    <select class="form-select" [ngModel]="formato" (ngModelChange)="formatoChange.emit($event)">
      <option value="csv">CSV</option>
      <option value="txt">TXT</option>
      <option value="pdf">PDF</option>
    </select>
  </div>
  <div class="col-12 d-flex flex-wrap gap-2">
    <button class="btn btn-primary crud-footer-btn" [disabled]="!funcionarioSelecionado" (click)="pesquisar.emit()">Pesquisar</button>
    <button class="btn btn-warning crud-footer-btn text-white" (click)="limpar.emit()">Limpar</button>
    <button class="btn btn-success crud-footer-btn" (click)="gerar.emit()">Gerar</button>
    <button
      type="button"
      class="btn btn-outline-primary crud-footer-btn"
      [disabled]="!empregadorSelecionado || !funcionarioSelecionado"
      (click)="acertoServidor.emit()">
      Acerto do servidor
    </button>
    <button
      type="button"
      class="btn btn-outline-secondary crud-footer-btn"
      [disabled]="!empregadorSelecionado"
      (click)="acertoGeral.emit()">
      Acerto geral
    </button>
  </div>
</div>
